import { Container, Row, Col, Button } from "react-bootstrap";
import { useAuth } from "./AuthContext";

export default function AccessDenied() {
  const { logout, vaAccessDenied } = useAuth();

  return (
    <Container fluid className="d-flex vh-100 align-items-center justify-content-center bg-light">
      <Row className="text-center">
        <Col>
          <h1 className="display-4 fw-bold text-danger">Access Denied</h1>
          <p className="text-muted mb-4">
            {vaAccessDenied
              ? "Your account is not registered as a VA distributor. Ask an admin to add you first."
              : "You do not have permission to view this page."}
          </p>
          <Button variant="primary" onClick={logout}>
            Back to Login
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
